module.exports = __webpack_public_path__ + "media/newstyle/images/icon-export-afc1b333b552d0d877c1091f1cf96c0e.svg";